// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"386163a5","217":"a101ef18","219":"5d8dfa61","230":"85fdc203","514":"010c1573","692":"5a91ba0a","796":"98611eea","839":"09104f54","864":"f1b8d3f4"}[chunkId] + ".chunk.js";
};